import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import Header from './Components/Header';
import Home from "./Pages/Home";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
    return (
        <Router>
            <Header />
            <div className="container">
                <Switch>
                    <Route path="/">
                        <Home />
                    </Route>
                </Switch>
                <ToastContainer />
            </div>
        </Router>
    );
}

export default App;
